<router-outlet></router-outlet>
<div class="spinner-container" *ngIf="showSpin">
    <mat-spinner></mat-spinner>  
</div>
